import { useState } from 'react';
import SiteHeader from '@/pages/home/components/SiteHeader';
import HeroSection from '@/pages/home/components/HeroSection';
import TopicWall from '@/pages/home/components/TopicWall';
import QuickBrief from '@/pages/home/components/QuickBrief';
import TimelineSection from '@/pages/home/components/TimelineSection';
import DossierSection from '@/pages/home/components/DossierSection';
import CommentSection from '@/pages/home/components/CommentSection';
import EntranceSection from '@/pages/home/components/EntranceSection';
import SubscribeBand from '@/pages/home/components/SubscribeBand';
import SiteFooter from '@/pages/home/components/SiteFooter';

export default function Home() {
  const [query, setQuery] = useState('');
  const [activeTag, setActiveTag] = useState('');

  const goToBrief = (tag: string) => {
    setActiveTag(tag);
    document.getElementById('brief')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <div className="min-h-screen w-full bg-background-50">
      <SiteHeader />
      <main className="w-full">
        <HeroSection query={query} onQueryChange={setQuery} onTagShortcut={goToBrief} />
        <TopicWall activeTag={activeTag} onSelectTag={goToBrief} />
        <QuickBrief
          query={query}
          onQueryChange={setQuery}
          activeTag={activeTag}
          onSelectTag={setActiveTag}
        />
        <TimelineSection />
        <DossierSection />
        <CommentSection />
        <EntranceSection />
        <SubscribeBand />
      </main>
      <SiteFooter />
    </div>
  );
}